/**
 * Read a duration token (e.g. `--transition-time-drawer: 680ms`) from the
 * live CSS so JS timers that wait for a CSS animation — unmount after a
 * close animation, "entered" flags — follow the Figma token instead of a
 * hardcoded copy. Read at call time: the value is brand-scoped
 * (`:root[data-brand]`) and may change with the brand.
 *
 * @param {string} varName   custom property name, e.g. '--transition-time-drawer'
 * @param {number} fallback  ms used when the token is missing or unparsable
 * @returns {number} duration in ms
 */
export function readCssDurationMs(varName, fallback) {
  if (typeof window === 'undefined' || !window.getComputedStyle) return fallback;
  const raw = window.getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
  const match = /^(-?\d*\.?\d+)(ms|s)$/.exec(raw);
  if (!match) return fallback;
  const value = Number(match[1]);
  return match[2] === 's' ? value * 1000 : value;
}

// Last-resort value for environments without the generated theme (tests).
const DRAWER_FALLBACK_MS = 680;

/** Duration of popup/drawer open-close animations (`--transition-time-drawer`). */
export function drawerDurationMs() {
  return readCssDurationMs('--transition-time-drawer', DRAWER_FALLBACK_MS);
}
